import { createFileRoute, Outlet } from "@tanstack/react-router";
import { fetchOrgDocument, getRawOrgDocumentQueryKey } from "~/data/orgs";

export const Route = createFileRoute("/_protected/(org)/_org-layout/orgs/$orgId")({
  loader: async ({ params, context }) => {
    const { orgId } = params;
    await context.queryClient.ensureQueryData({
      queryKey: getRawOrgDocumentQueryKey(orgId),
      queryFn: () => fetchOrgDocument(orgId),
    });
  },
  component: Outlet,
});
